import { useFeatureFlag } from './useFeatureFlag'

export const useShowCardStudio = () => {
  const touchDevicesEnabled = useFeatureFlag('cash-web-account-enable-card-studio-touch-devices')

  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0

  return Boolean(!isTouchDevice || touchDevicesEnabled)
}
